export default function isBetween(num: number, min: number, max: number) {
  return num >= min && num <= max;
}
